/// <reference path="../../@types/index.d.ts" />
import { VelocityComponent } from "velocity-react";
export var Animate = VelocityComponent;
//# sourceMappingURL=Animate.js.map